import { YOO_FINDS_CDN } from "@/common";
const ROOT = `${YOO_FINDS_CDN}/h5/product`;
export const PRODUCT_RIGHT_ARROW = `${ROOT}/direction.png?imageMogr2/thumbnail/!80p/format/webp`;
export const PRODUCT_TOP_FLOWER = `${ROOT}/bg-vector.png?imageMogr2/thumbnail/!80p/format/webp`;
export const PRODUCT_CLOSE_ICON = `${ROOT}/close-blue-v1.png?imageMogr2/thumbnail/!80p/format/webp`;
export const PRODUCTS_BANNER_LOGO = `${ROOT}/product-banner-logo-v1.png`;
export const PRODUCT_TAG_LOGO = `${ROOT}/yf-tag-logo.svg`;
export const PRODUCT_ICON_FAIR = `${ROOT}/yf-icon-arrow.png?imageMogr2/thumbnail/!80p/format/webp`;
export const MASK_CLOSE_ICON_BLUE = `${ROOT}/close-blue-v1.png?imageMogr2/thumbnail/!80p/format/webp`;
export const PRODUCT_BG_VECTOR = `${ROOT}/bg-vector.png?imageMogr2/thumbnail/!80p/format/webp`;
export const PRODUCT_DIRECTION = `${ROOT}/direction.png?imageMogr2/thumbnail/!80p/format/webp`;
export const PRICE_ICON = `${ROOT}/price-icon.svg`;
export const STOCK_ICON = `${ROOT}/stock-icon.svg`;
export const RATINGS_ICON = `${ROOT}/rating-icon.svg`;
export const SAMPLE_ICON = `${ROOT}/sample-icon.svg`;
export const RIGHT_ARROW = `${ROOT}/right-arrow-large.svg`;
export const RIGHT_ARROW_ROUND = `${ROOT}/right-arrow-v1.svg`;
export const PROCESS_ICON1 = `${ROOT}/process-icon1A.svg`;
export const PROCESS_ICON2 = `${ROOT}/process-icon2A.svg`;
export const PROCESS_ICON3 = `${ROOT}/process-icon3A.svg`;
export const SHOP_NAME_ICON = `${ROOT}/shop-name-icon.svg`;
export const SHOP_RATINGS_ICON = `${ROOT}/shop-ratings-icon.svg`;
export const SHOP_SOLD_ICON = `${ROOT}/shop-sold-icon.svg`;
export const SHOP_LABEL_ICON = `${ROOT}/shop-label-icon.svg`;
export const FAVORITES_ICON = `${ROOT}/favorites.svg`;
export const COMMISSION_LOGO = `${ROOT}/commission-logo.svg`;
export const PLAY_ICON = `${ROOT}/play-icon.svg`;
export const COMMISSION_ARROW = `${ROOT}/green-arrow.png`;
export const COMMISSION_LINE = `${ROOT}/flash-line.png`;
export const COMMISSION_SLINE = `${ROOT}/short-line.png`;
export const COMMISSION_TRIANGLE = `${ROOT}/triangle.png`;
export const COMMISSION_UP_ARROW = `${ROOT}/up-arrow.png`;
